import { RuleTableHandlers, TableConfig } from '../../../../shared/ui/custom-table/model/table-config.model';

export enum BookingTableRowAction {
  View = 'view',
  Edit = 'edit',
  Cancel = 'cancel'
}

export function createBookingTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string } = {}
): TableConfig {
  const {
    onCreate = () => { },
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    columns = [],
  } = handlers;

  const handleAction = (row: any, action: BookingTableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns,
    actions: [
      { label: 'Ver', icon: 'visibility', callback: (row) => handleAction(row, BookingTableRowAction.View) },
      { label: 'Editar', icon: 'edit', callback: (row) => handleAction(row, BookingTableRowAction.Edit) },
      { label: 'Cancelar', icon: 'cancel', callback: (row) => handleAction(row, BookingTableRowAction.Cancel) }
    ],
    headerActions: [
      // { label: 'Nueva reserva', icon: 'fa fa-plus', type: 'button', callback: onCreate }
    ],
    filterView: options.filterView || 'bookings',
    rowConfig: {
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
    },
    selectable: false,
    pagination: true
  };
}
